<template>
    <v-btn
            id="botaoSalvar"
            color="primary"
            depressed
            :disabled="disabled"
            @click="$emit('salvar')">
        {{texto}}
    </v-btn>
</template>

<script>
export default {
    name: 'BotaoSalvar',
    props:{
        disabled:{
            type: Boolean,
            default: false
        },
        texto:{
            type: String,
            default: 'Salvar'
        }
    }
}
</script>